import React from 'react';

/* Imports */
import CheckCircleIcon from '~/../symbols/check.svg';
import { Button } from '~/components/common';
import { Icon } from '~/components/common';

export default function ProductOverviewBanner({
    title,
    subtitle,
    text,
    textColor,
    usps,
    links,
    image,
    icon = CheckCircleIcon,
}) {
    return (
        <article className={`card card--link d-flex m-4 m-md-0 card--vehicles-banner card--${textColor === 'base' ? 'white' : 'base'}`}>
            {image &&
                <div className="card__background fade-bottom--large">
                    <picture>
                        <source
                            srcSet={`${image.formats["370x384"]} 1x, ${image.formats["740x768"]} 2x`}
                            media="(min-width: 1920px)"/>
                        <source
                            srcSet={`${image.formats["370x384"]} 1x, ${image.formats["740x768"]} 2x`}
                            media="(min-width: 1680px)"/>
                        <source
                            srcSet={`${image.formats["315x327"]} 1x, ${image.formats["630x654"]} 2x`}
                            media="(min-width: 1440px)"/>
                        <source
                            srcSet={`${image.formats["373x387"]} 1x, ${image.formats["746x774"]} 2x`}
                            media="(min-width: 1280px)"/>
                        <source
                            srcSet={`${image.formats["440x456"]} 1x, ${image.formats["880x912"]} 2x`}
                            media="(min-width: 992px)"/>
                        <source
                            srcSet={`${image.formats["320x332"]} 1x, ${image.formats["640x664"]} 2x`}
                            media="(min-width: 768px)"/>
                        <source
                            srcSet={`${image.formats["520x540"]} 1x, ${image.formats["1040x1080"]} 2x`}
                            media="(min-width: 600px)"/>
                        <img className="card__background-image img-fluid fade-bottom--large"
                             src={`${image.formats["540x560"]}`}
                             srcSet={`${image.formats["1080x720"]} 2x `} alt={`${image.title}`} loading="lazy"
                        />
                    </picture>
                </div>
            }
            <div className="card-body position-relative d-flex flex-column p-4 p-lg-6 justify-content-end">
                {subtitle && <div className="text--subtitle mb-0 mb-lg-2 text-primary">{subtitle}</div>}
                {title && <div className="card__text h6">{title}</div>}
                {text && <div className="card__text mb-6" dangerouslySetInnerHTML={{__html: text}}/>}
                {usps &&
                    <div className="row usps gutters-2 gutters-lg-3">
                        {usps.map((usp, index) => {
                            return (
                                <div className="col-12 usps__item d-flex" key={index}>
                                    <Icon
                                        className={`icon--circle-sm icon--with-circle icon--with-circle-outline-${textColor}`}
                                        url={icon?.url}
                                    />
                                    <p className="usps__text ml-2 ml-lg-4">{usp.text}</p>
                                </div>
                            );
                        })}
                    </div>
                }
                {links[0] &&
                    <Button
                        className="btn-block"
                        href={links[0].href}
                        theme={links[0].theme}
                        title={links[0].title}
                        target={links[0].target}
                        iconSize={16}
                        loadingSize={16}
                    />
                }
            </div>
        </article>
    );
}
